import { render, staticRenderFns } from "./AI-New-Basic.vue?vue&type=template&id=1c793565&scoped=true&"
import script from "./AI-New-Basic.vue?vue&type=script&lang=js&"
export * from "./AI-New-Basic.vue?vue&type=script&lang=js&"
import style0 from "./AI-New-Basic.vue?vue&type=style&index=0&id=1c793565&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c793565",
  null
  
)

export default component.exports